// 点検明細単位の写真・コメント登録モーダル。
// _attachment_modal.html.erb がレンダリングする DOM（dialog + js-* ハンドラ + 設定JSON）を操作する。
// 旧 × オーバーレイ UI を廃し、新 UI（ファイル名 + 削除ボタン）へ統一。実処理はこのモジュールへ一本化する
// （以前は ERB 内インライン JS と二重実装だった）。
// 編集ページ: multipart/form-data で controller に PATCH。新規ページ: DirectUpload で stash（hidden field 反映）。
//
// バインドは document への委譲で「1回だけ」行う。Turbolinks で body / モーダルが入れ替わっても
// 多重バインドせず、後から追加されたモーダルにも反応する。
 
(function () {
  var state = {
    pending: [], existing: [], detailUrl: null, detailId: null,
    rowKey: null, stashMode: false, deleteUrlTemplate: null
  };
  // ページごとの設定（MAX_PHOTOS / VIEW_ONLY）はモーダルを開く度に設定JSONから読み直す。
  var config = { maxPhotos: 0, viewOnly: false };
 
  function refreshConfig() {
    var node = document.querySelector('.js-inspection-detail-attachment-config');
    if (!node) return;
    try {
      var parsed = JSON.parse(node.textContent) || {};
      config.maxPhotos = parsed.maxPhotos || 0;
      config.viewOnly = !!parsed.viewOnly;
    } catch (e) { /* noop */ }
  }
 
  function csrfToken() {
    var meta = document.querySelector('meta[name="csrf-token"]');
    return meta ? meta.getAttribute('content') : '';
  }
 
  function getModal() { return document.getElementById('inspection-detail-attachment-modal'); }
 
  function showModal() {
    var m = getModal();
    if (!m) return;
    if (typeof m.showModal === 'function') m.showModal();
    else { m.setAttribute('open', ''); m.style.display = 'block'; }
  }
 
  function hideModal() {
    var m = getModal();
    if (!m) return;
    if (typeof m.close === 'function') m.close();
    else { m.removeAttribute('open'); m.style.display = 'none'; }
  }
 
  function fileKey(f) { return f.name + '|' + f.size + '|' + f.lastModified; }
 
  function isImage(f) { return f && f.type && f.type.indexOf('image/') === 0; }
 
  function buildExistingCard(photo) {
    var card = document.createElement('div');
    card.className = 'attachment-card';
 
    var img = document.createElement('img');
    img.src = photo.url;
    img.className = 'attachment-card__thumb';
    card.appendChild(img);
 
    var footer = document.createElement('div');
    footer.className = 'attachment-card__footer';
 
    var name = document.createElement('span');
    name.className = 'attachment-card__name';
    name.title = photo.filename;
    name.textContent = photo.filename;
    footer.appendChild(name);
 
    if (!config.viewOnly) {
      var del = document.createElement('button');
      del.type = 'button';
      del.className = 'attachment-card__delete';
      del.textContent = '削除';
      del.addEventListener('click', function () { deleteExistingPhoto(photo.id); });
      footer.appendChild(del);
    }
 
    card.appendChild(footer);
    return card;
  }
 
  function buildPendingCard(item) {
    var card = document.createElement('div');
    card.className = 'attachment-card';
 
    if (item.previewUrl) {
      var img = document.createElement('img');
      img.src = item.previewUrl;
      img.className = 'attachment-card__thumb';
      card.appendChild(img);
    }
 
    var footer = document.createElement('div');
    footer.className = 'attachment-card__footer';
 
    var name = document.createElement('span');
    name.className = 'attachment-card__name';
    name.title = item.file.name;
    name.textContent = item.file.name;
    footer.appendChild(name);
 
    var del = document.createElement('button');
    del.type = 'button';
    del.className = 'attachment-card__delete';
    del.textContent = '削除';
    del.addEventListener('click', function () {
      if (item.previewUrl) URL.revokeObjectURL(item.previewUrl);
      // 描画時の index ではなく、クリック時点の item の現在位置を引き直す（再描画ずれに強い）。
      var pos = state.pending.indexOf(item);
      if (pos !== -1) state.pending.splice(pos, 1);
      renderPreview();
    });
    footer.appendChild(del);
 
    card.appendChild(footer);
    return card;
  }
 
  function deleteExistingPhoto(photoId) {
    if (!window.confirm('この写真を削除しますか？')) return;
 
    // 新規ページ (stash モード): サーバには未保存。state.existing から除外し hidden fields を更新するだけ。
    if (state.stashMode) {
      state.existing = state.existing.filter(function (p) {
        return p.id !== photoId && p.signed_id !== photoId;
      });
      var commentEl = document.getElementById('inspection-detail-attachment-modal__comment');
      var commentVal = commentEl ? commentEl.value : '';
      writeStashFields(state.rowKey, commentVal, state.existing);
      var stashTrigger = document.querySelector('.js-open-attachment-modal[data-row-key="' + state.rowKey + '"]');
      if (stashTrigger) stashTrigger.dataset.existingPhotos = JSON.stringify(state.existing);
      updateRowBadge(state.rowKey, state.existing.length, !!commentVal.trim());
      renderPreview();
      return;
    }
 
    // 編集ページ (AJAX モード): サーバに DELETE を投げて反映
    if (!state.deleteUrlTemplate) return;
 
    fetch(state.deleteUrlTemplate.replace('__ID__', encodeURIComponent(photoId)), {
      method: 'DELETE',
      headers: { 'X-CSRF-Token': csrfToken(), 'Accept': 'application/json' }
    })
      .then(function (resp) { return resp.json(); })
      .then(function (data) {
        if (data.ok) {
          state.existing = data.photos || [];
          renderPreview();
          updateRowBadge(state.rowKey || state.detailId, data.photos_count, data.comment_present);
          // ボタンの data-existing-photos も更新（再オープン時のため）
          var trigger = document.querySelector('.js-open-attachment-modal[data-row-key="' + state.rowKey + '"]')
            || document.querySelector('.js-open-attachment-modal[data-detail-id="' + state.detailId + '"]');
          if (trigger) trigger.dataset.existingPhotos = JSON.stringify(state.existing);
        } else {
          window.alert(data.error || '写真の削除に失敗しました');
        }
      })
      .catch(function (err) { window.alert('リクエスト失敗: ' + err.message); });
  }
 
  function renderPreview() {
    var root = document.getElementById('inspection-detail-attachment-modal__root');
    if (!root) return;
    root.innerHTML = '';
 
    var total = state.existing.length + state.pending.length;
    if (total === 0) {
      // 空状態: ダッシュ枠と「画像はまだ登録されていません」テキストのみ
      root.classList.add('is-empty');
      var emptyMsg = document.createElement('div');
      emptyMsg.className = 'attachment-empty-text';
      emptyMsg.textContent = '画像はまだ登録されていません';
      root.appendChild(emptyMsg);
    } else {
      root.classList.remove('is-empty');
      // 既存写真を先に表示
      state.existing.forEach(function (photo) {
        root.appendChild(buildExistingCard(photo));
      });
      // 追加待ち（未送信）写真
      state.pending.forEach(function (item) {
        root.appendChild(buildPendingCard(item));
      });
    }
 
    var countEl = document.querySelector('.js-inspection-detail-attachment-count');
    if (countEl) {
      if (config.viewOnly) {
        countEl.textContent = '登録済: ' + state.existing.length + '件';
      } else {
        countEl.textContent = '登録済: ' + state.existing.length + '件 / 追加待ち: ' + state.pending.length + '件 / 上限: ' + config.maxPhotos + '件';
      }
    }
  }
 
  function handleFileSelect(event) {
    var files = Array.prototype.slice.call(event.target.files || []);
    if (files.length === 0) return;
 
    var imageFiles = files.filter(isImage);
    if (imageFiles.length !== files.length) {
      window.alert('画像ファイル以外は登録できません。');
    }
 
    var totalAfter = state.existing.length + state.pending.length + imageFiles.length;
    if (totalAfter > config.maxPhotos) {
      window.alert('写真は最大' + config.maxPhotos + '件までです（登録済: ' + state.existing.length + '件、追加待ち: ' + state.pending.length + '件、選択: ' + imageFiles.length + '件）');
      event.target.value = '';
      return;
    }
 
    imageFiles.forEach(function (f) {
      if (state.pending.find(function (p) { return p.key === fileKey(f); })) return;
      var previewUrl = null;
      try { previewUrl = URL.createObjectURL(f); } catch (e) { /* noop */ }
      state.pending.push({ key: fileKey(f), file: f, previewUrl: previewUrl });
    });
 
    event.target.value = '';
    renderPreview();
  }
 
  function openModalFor(btn) {
    refreshConfig(); // ページごとの MAX_PHOTOS / VIEW_ONLY を最新化
    state.detailUrl = btn.dataset.detailUrl || null;     // AJAX mode if present
    state.detailId = btn.dataset.detailId || null;
    state.rowKey = btn.dataset.rowKey || null;           // stash mode key for new page
    state.stashMode = !state.detailUrl;                  // new ページ = stash モード
    state.deleteUrlTemplate = btn.dataset.detailDeleteUrlTemplate || null;
    state.pending.forEach(function (p) { if (p.previewUrl) URL.revokeObjectURL(p.previewUrl); });
    state.pending = [];
 
    // 既存写真を data-existing-photos JSON から読み取り
    state.existing = [];
    var raw = btn.dataset.existingPhotos;
    if (raw) {
      try {
        var parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) state.existing = parsed;
      } catch (e) { /* noop */ }
    }
 
    var nameEl = document.getElementById('inspection-detail-attachment-modal__item-name');
    if (nameEl) nameEl.textContent = btn.dataset.itemName || '';
    var commentEl = document.getElementById('inspection-detail-attachment-modal__comment');
    if (commentEl) commentEl.value = btn.dataset.existingComment || '';
 
    renderPreview();
    showModal();
  }
 
  function submitForm() {
    if (state.stashMode) { submitStash(); return; }
    submitAjax();
  }
 
  // 編集ページ用: AJAX で controller に PATCH
  function submitAjax() {
    if (!state.detailUrl) { window.alert('登録対象が見つかりません'); return; }
 
    var submitBtn = document.querySelector('.js-inspection-detail-attachment-submit');
    if (submitBtn) {
      submitBtn.classList.add('loading', 'disabled');
      submitBtn.disabled = true;
    }
 
    var form = new FormData();
    var commentEl = document.getElementById('inspection-detail-attachment-modal__comment');
    form.append('remarks', commentEl ? commentEl.value : '');
    state.pending.forEach(function (p) { form.append('photos[]', p.file); });
 
    fetch(state.detailUrl, {
      method: 'PATCH',
      headers: { 'X-CSRF-Token': csrfToken(), 'Accept': 'application/json' },
      body: form
    })
      .then(function (resp) { return resp.json(); })
      .then(function (data) {
        if (submitBtn) {
          submitBtn.classList.remove('loading', 'disabled');
          submitBtn.disabled = false;
        }
        if (data.ok) {
          // 既存写真リストを最新化（次回オープン時に表示するため）
          var trigger = document.querySelector('.js-open-attachment-modal[data-row-key="' + state.rowKey + '"]');
          if (data.photos) {
            state.existing = data.photos;
            if (trigger) trigger.dataset.existingPhotos = JSON.stringify(state.existing);
          }
          // コメントも次回オープン用に保存
          var savedCommentEl = document.getElementById('inspection-detail-attachment-modal__comment');
          if (trigger && savedCommentEl) trigger.dataset.existingComment = savedCommentEl.value;
          // pending の preview URL を破棄してクリア
          state.pending.forEach(function (p) { if (p.previewUrl) URL.revokeObjectURL(p.previewUrl); });
          state.pending = [];
          updateRowBadge(state.rowKey, data.photos_count, data.comment_present);
          hideModal();
        } else {
          window.alert(data.error || '登録に失敗しました');
        }
      })
      .catch(function (err) {
        if (submitBtn) {
          submitBtn.classList.remove('loading', 'disabled');
          submitBtn.disabled = false;
        }
        window.alert('リクエスト失敗: ' + err.message);
      });
  }
 
  // 新規ページ用: DirectUpload で signed_id 取得後、hidden field に保存。フォーム送信時に親フォームと一緒に POST される。
  // ActiveStorage はアプリの webpacker バンドル（direct-upload.js）が window.ActiveStorage として公開済み。
  // 外部 CDN からの動的ロードは CSP / サプライチェーン / バージョン不整合のリスクがあるため行わず、
  // バンドルが読み込めていない場合は明示的に失敗させる（呼び出し側の .catch でユーザーに通知）。
  function ensureActiveStorage() {
    return new Promise(function (resolve, reject) {
      if (window.ActiveStorage && window.ActiveStorage.DirectUpload) {
        resolve(window.ActiveStorage);
      } else {
        reject(new Error('ActiveStorage を読み込めませんでした。ページを再読み込みしてからお試しください。'));
      }
    });
  }
 
  function submitStash() {
    var submitBtn = document.querySelector('.js-inspection-detail-attachment-submit');
    if (submitBtn) {
      submitBtn.classList.add('loading', 'disabled');
      submitBtn.disabled = true;
    }
 
    var commentEl = document.getElementById('inspection-detail-attachment-modal__comment');
    var commentVal = commentEl ? commentEl.value : '';
 
    var directUploadInput = document.querySelector('.js-inspection-detail-attachment-input');
    var directUploadUrl = directUploadInput ? directUploadInput.dataset.directUploadUrl : null;
    if (!directUploadUrl) {
      if (submitBtn) {
        submitBtn.classList.remove('loading', 'disabled');
        submitBtn.disabled = false;
      }
      window.alert('directUploadUrl が見つかりません');
      return;
    }
 
    var uploadAll = ensureActiveStorage().then(function (AS) {
      return Promise.all(state.pending.map(function (item) {
        return new Promise(function (resolve, reject) {
          var upload = new AS.DirectUpload(item.file, directUploadUrl);
          upload.create(function (error, blob) {
            if (error) return reject(error);
            resolve({ signed_id: blob.signed_id, filename: item.file.name, previewUrl: item.previewUrl });
          });
        });
      }));
    });
 
    uploadAll.then(function (uploaded) {
      // 既存（stash済）+ 新規アップロード分を統合
      var merged = state.existing.concat(uploaded.map(function (u) {
        return { id: u.signed_id, url: u.previewUrl, filename: u.filename, signed_id: u.signed_id };
      }));
 
      // hidden field を更新
      writeStashFields(state.rowKey, commentVal, merged);
 
      // ボタンの data-existing-photos と data-existing-comment を更新（次回オープン用）
      var trigger = document.querySelector('.js-open-attachment-modal[data-row-key="' + state.rowKey + '"]');
      if (trigger) {
        trigger.dataset.existingPhotos = JSON.stringify(merged);
        trigger.dataset.existingComment = commentVal;
      }
 
      state.existing = merged;
      state.pending = [];
      updateRowBadge(state.rowKey, merged.length, !!commentVal.trim());
 
      if (submitBtn) {
        submitBtn.classList.remove('loading', 'disabled');
        submitBtn.disabled = false;
      }
      hideModal();
    }).catch(function (err) {
      if (submitBtn) {
        submitBtn.classList.remove('loading', 'disabled');
        submitBtn.disabled = false;
      }
      window.alert('アップロード失敗: ' + err.message);
    });
  }
 
  // 新規ページ用: 該当行の hidden field（remarks と photo_signed_ids[]）を更新
  function writeStashFields(rowKey, commentVal, photos) {
    var remarksEl = document.querySelector('.js-attachment-stash-remarks[data-row-key="' + rowKey + '"]');
    if (remarksEl) remarksEl.value = commentVal;
 
    var container = document.querySelector('.js-attachment-stash-photos[data-row-key="' + rowKey + '"]');
    if (!container) return;
    var fieldName = container.dataset.fieldName;
    // 既存の hidden input を全削除して再生成
    container.innerHTML = '';
    photos.forEach(function (photo) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = fieldName;
      input.value = photo.signed_id || photo.id;
      container.appendChild(input);
    });
  }
 
  // 全ての行は data-row-key で識別する（編集ページ・新規ページ共通）
  function updateRowBadge(rowKey, count, commentPresent) {
    var badge = document.querySelector('.js-attachment-summary[data-row-key="' + rowKey + '"]');
    if (!badge) return;
    var c = badge.querySelector('.js-photo-count');
    var f = badge.querySelector('.js-comment-flag');
    if (c) c.textContent = count;
    if (f) f.textContent = commentPresent ? '有' : '無';
    badge.style.display = (count > 0 || commentPresent) ? '' : 'none';
  }
 
  // document へ1回だけ委譲バインドする。open / close / submit / 入力変更 / 背景クリックを集約。
  function setupOnce() {
    if (window.__inspectionAttachmentBound) return;
    window.__inspectionAttachmentBound = true;
 
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('.js-open-attachment-modal');
      if (trigger) { event.preventDefault(); openModalFor(trigger); return; }
 
      var closeBtn = event.target.closest('.js-inspection-detail-attachment-close');
      if (closeBtn) { event.preventDefault(); hideModal(); return; }
 
      var submitBtn = event.target.closest('.js-inspection-detail-attachment-submit');
      if (submitBtn) { event.preventDefault(); submitForm(); return; }
 
      // dialog の背景（要素自身）クリックで閉じる
      var modal = getModal();
      if (modal && event.target === modal) { hideModal(); }
    });
 
    document.addEventListener('change', function (event) {
      if (event.target.closest('.js-inspection-detail-attachment-input')) {
        handleFileSelect(event);
      }
    });
  }
 
  // 初回ロード・Turbolinks 遷移の双方で setupOnce を呼ぶ（ガードで多重バインドは防止済み）。
  document.addEventListener('turbolinks:load', setupOnce);
  document.addEventListener('DOMContentLoaded', setupOnce);
  if (document.readyState !== 'loading') setupOnce();
})();